<template>
  <div>
    <template v-if="!loading">
      <div class="smp__supports-tabs smp__supports-tabs-parent">
        <button
          v-for="(sup, index) in supportsType"
          :key="index"
          :class="['smp__tab', { 'smp__tab--active': currentTab === sup }]"
          @click="handleTabChange(sup)"
        >
          {{ sup }}
        </button>
      </div>
      <div class="smp__supports-tabs">
        <button
          v-for="(sup, index) in subTabs"
          :key="index"
          :class="[
            'smp__tab',
            { 'smp__tab--active': subCurrentTab.name === sup.name }
          ]"
          @click="handleSubtabChang(sup)"
        >
          {{ sup.name }}
        </button>
      </div>
    </template>
    <template v-else>
      <div class="smp__supports-tabs">
        <button class="smp__tab smp__tab--active loading"></button>
        <button class="smp__tab loading"></button>
        <button class="smp__tab loading"></button>
        <button class="smp__tab loading"></button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  props: {
    supportsType: {
      type: Array,
      required: true
    },
    support: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentTab: null,
      loading: true,
      subCurrentTab: {
        id: 1,
        sup: ["Hologramme 1", "Hologramme 2", "Hologramme 3", "Hologramme 4"]
      },
      subSupportsArr: [
        {
          id: 1,
          sup: ["Hologramme 1", "Hologramme 2", "Hologramme 3", "Hologramme 4"]
        },
        {
          id: 2,
          sup: [
            "Ecran vitrine 1",
            "Ecran vitrine 2",
            "Ecran vitrine 3",
            "Ecran vitrine 4",
            "Ecran vitrine 5"
          ]
        },
        {
          id: 3,
          sup: [
            "Video projecteur 1",
            "Video projecteur 2",
            "Video projecteur 3",
            "Video projecteur 4",
            "Video projecteur 5",
            "Video projecteur 6"
          ]
        },
        { id: 4, sup: ["Bandeau LED 1", "Bandeau LED 2", "Bandeau LED 3"] },
        { id: 5, sup: ["test 1", "test 2"] },
        {
          id: 6,
          sup: [
            "toto 1",
            "toto 2",
            "toto 3",
            "toto 4",
            "toto 5",
            "toto 6",
            "toto 7",
            "toto 8"
          ]
        }
      ],
      selectedSubSupport: [],
      Hologrammes: [
        { id: 1, name: "Hologramme 1" },
        { id: 2, name: "Hologramme 2" },
        { id: 3, name: "Hologramme 3" },
        { id: 4, name: "Hologramme 4" },
        { id: 5, name: "Hologramme 5" }
      ],
      Ecranvitrines: [
        { id: 1, name: "Ecranvitrine 1" },
        { id: 2, name: "Ecranvitrine 2" },
        { id: 3, name: "Ecranvitrine 3" },
        { id: 4, name: "Ecranvitrine 4" },
        { id: 5, name: "Ecranvitrine 5" }
      ],
      Videoprojecteurs: [
        { id: 1, name: "Videoprojecteur 1" },
        { id: 2, name: "Videoprojecteur 2" },
        { id: 3, name: "Videoprojecteur 3" },
        { id: 4, name: "Videoprojecteur 4" },
        { id: 5, name: "Videoprojecteur 5" }
      ],
      Bandeauleds: [
        { id: 1, name: "Bandeauled 1" },
        { id: 2, name: "Bandeauled 2" },
        { id: 3, name: "Bandeauled 3" },
        { id: 4, name: "Bandeauled 4" },
        { id: 5, name: "Bandeauled 5" }
      ],
      tests: [
        { id: 1, name: "test 1" },
        { id: 2, name: "test 2" },
        { id: 3, name: "test 3" },
        { id: 4, name: "test 4" },
        { id: 5, name: "test 5" }
      ],
      totos: [
        { id: 1, name: "toto 1" },
        { id: 2, name: "toto 2" },
        { id: 3, name: "toto 3" },
        { id: 4, name: "toto 4" },
        { id: 5, name: "toto 5" }
      ]
    }
  },
  computed: {
    ...mapState(["supports"]),
    subTabs() {
      return this.selectedSubSupport.filter(
        support => this.currentTab === support.type
      )
    }
  },
  methods: {
    handleTabChange(support) {
      this.currentTab = support
      this.changeSubTab()
    },
    handleSubtabChang(tab) {
      this.subCurrentTab = tab
      this.$emit("planning-tab-change", this.subCurrentTab)
    },
    changeSubTab() {
      this.selectedSubSupport = [...this.support]
      this.subCurrentTab = this.selectedSubSupport.filter(
        support => this.currentTab === support.type
      )[0]
      this.$emit("planning-tab-change", this.subCurrentTab)
    },
    resetTab() {
      this.currentTab = this.supportsType[0]
      this.changeSubTab()
    }
  },
  mounted() {
    this.loading = false
    this.currentTab = this.supportsType[0]
    this.changeSubTab()
    // this.changeSubTab()
  },
  watch: {
    supports: {
      handler(newVal) {
        if (newVal.data.options.length) {
          this.loading = false
          this.currentTab = newVal.data.options[0]
        }
      },
      deep: true
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.smp {
  &__supports-tabs {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    margin-bottom: 40px;
    &-parent {
      margin-bottom: 0;
    }
  }
  &__tab {
    cursor: pointer;
    outline: none;
    font-family: $font-family-muli;
    letter-spacing: 0.2px;
    font-weight: 800;
    // width: 25%;
    width: 100%;
    font-size: 0.8em;
    padding: 13px 16px 12px;
    border: none;
    background: $color-neutral-2;
    background: var(--color-neutral-2, $color-neutral-2);
    color: $color-neutral-4;
    color: var(--color-neutral-4, $color-neutral-4);
    transition: all 0.3s ease-in;
    &--active {
      background: $color-accent;
      background: var(--color-accent, $color-accent);
      color: white;
      box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.2);
    }
    &:not(&--active) {
      &:focus,
      &:hover {
        box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.2);
      }
    }

    &.loading {
      position: relative;
      text-align: center;
      padding: 20px;
      &:before {
        position: absolute;
        content: " ";
        top: 20%;
        left: 0;
        width: 50%;
        height: 13px;
        transform: translate(50%, 50%);
        background: rgba(220, 196, 196, 0.25);
      }
    }
  }
}
</style>
